import {buildConfiguration as baseBuildConfiguration, FieldsConfiguration} from '../../../fields'
import {BuildConfigurationInput} from '../../../types'
import {OrderDto} from '../../types'
import {ChangeableFieldsOptionsDto} from '../options/types'

import {buildLoadBalanceConfiguration} from './loadBalance/buildLoadBalanceConfiguration'
import {buildLoadSpacingConfiguration} from './loadSpacing/buildLoadSpacingConfiguration'
import {buildTruckConfiguration} from './trucks/buildTruckConfiguration'

export const buildConfiguration = (
  order: OrderDto,
  input: BuildConfigurationInput,
  changeableFields: ChangeableFieldsOptionsDto,
  respectStartedOrderSpacingRestrictions = false
): FieldsConfiguration => {
  const baseConfiguration = baseBuildConfiguration(input)
  const configuration: FieldsConfiguration = {
    ...baseConfiguration,
    // order management overrides
    mix: {...baseConfiguration.mix, restrictMaterialsToSelectedContract: true},
    ...buildTruckConfiguration(order, input),
    ...buildLoadBalanceConfiguration(input, changeableFields)
  }

  return {
    ...configuration,
    ...buildLoadSpacingConfiguration(
      order,
      configuration,
      changeableFields,
      respectStartedOrderSpacingRestrictions
    )
  }
}
